module.exports = __webpack_public_path__ + "static/img/1889_phase_function_Paper_Points.f3d2bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1889_phase_function_Paper_Points.png
// module id = 38bL
// module chunks = 0